// extracted by mini-css-extract-plugin
module.exports = {"searchBar":"SearchBar_searchBar__2K7Qn","wrapCenter":"SearchBar_wrapCenter__2Dxhg"};